import { render, staticRenderFns } from "./InformationShow.vue?vue&type=template&id=37b4919a&scoped=true&"
import script from "./InformationShow.vue?vue&type=script&lang=js&"
export * from "./InformationShow.vue?vue&type=script&lang=js&"
import style0 from "./InformationShow.vue?vue&type=style&index=0&id=37b4919a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b4919a",
  null
  
)

export default component.exports